import React from 'react';
import { FunctionComponent } from 'react';
import HomePageMenu from './HomePageMenu';
import {HomePageMenuItem} from './HomePageMenuItemComp';
import HomeMainSlider, { MainSliderThumbnail } from './HomeMainSlider';
import HomeMiniSlider, { MiniSliderThumbnail } from './HomeMiniSlider';
import HomeMiniSliderDesktopFirstImage from './HomeMiniSliderDesktopFirstImage';
import HomeNewsletterBox from './HomeNewsletterBox';
import HomePromoBox from './HomePromoBox';

interface HomePageFirstSectionProps
{
    menuItems: HomePageMenuItem[];
    mainSliderThumbnails: MainSliderThumbnail[];
    miniSliderThumbnails: MiniSliderThumbnail[];
}

/** Home page first section component. An extenstion of the PHP web page. */
const HomePageFirstSection: FunctionComponent<HomePageFirstSectionProps> = (props) =>
{
    /** Render */
    return (
        <div className="home-page-first-section">
            <div className="container home-container">
                <div className="home-menu-and-main-slider-section row">
                    <div className="home-page-first-section-left-col col d-none d-lg-block">
                        <HomePageMenu 
                            menuItems={props.menuItems}
                        />
                    </div>
                    <div className="home-page-first-section-right-col col">
                        <HomeMainSlider
                            mainSliderThumbnails={props.mainSliderThumbnails}
                        />
                    </div>
                </div>

                <div className="home-mini-slider-and-boxes-section row mb-3">
                    <div className="home-mini-slider-and-boxes-section-left home-page-first-section-left-col col d-none d-lg-block">
                        {props.miniSliderThumbnails.length > 0 &&
                            <HomeMiniSliderDesktopFirstImage miniSliderThumbnail={props.miniSliderThumbnails[0]} />
                        }
                    </div>
                    <div className="home-mini-slider-and-boxes-section-right home-page-first-section-right-col col">
                        <div className="home-mini-slider-wrapper pb-2">
                            <HomeMiniSlider miniSliderThumbnails={props.miniSliderThumbnails} />
                        </div>

                        <div className="home-boxes-wrapper row pt-2">
                            <div className="col-md-6 col-lg-8 mb-3 mb-md-0">
                                <HomeNewsletterBox />
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <HomePromoBox />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePageFirstSection;